import { IObjectsPool, SearchResult } from './interfaces';
import { ObjectType, AspObject } from './AspObject';
import * as aspObjects from './aspObjects';

export const tracksLayerID = "TracksLayer";
export const sensorTracksLayerID = "SensorTracksLayer";
export const angularTracksLayerID = "AngularTracksLayer";
export const sensorsLayerID = "SensorsLayer";
export const plotsLayerID = "PlotsLayer";

export class AspMngr {

  private objectsPools: Map<ObjectType, IObjectsPool> = new Map<ObjectType, IObjectsPool>();

  constructor() {
  }

  setSensorsPool(iSensorsPool) {
    aspObjects.setSensorsPool(iSensorsPool);
    this.addObjectsPool(iSensorsPool);
  }

  setPlotsPool(iPlotsPool) {
    aspObjects.setPlotsPool(iPlotsPool);
    this.addObjectsPool(iPlotsPool);
  }

  setTracksPool(iTracksPool) {
    aspObjects.setTracksPool(iTracksPool);
    this.addObjectsPool(iTracksPool);
  }

  setSensorTracksPool(iTracksPool) {
    aspObjects.setSensorTracksPool(iTracksPool);
    this.addObjectsPool(iTracksPool);
  }

  setAngularTracksPool(iTracksPool) {
    aspObjects.setAngularTracksPool(iTracksPool);
    this.addObjectsPool(iTracksPool);
  }

  setAlertPolygonsPool(iAlertPolygonsPool) {
    aspObjects.setAlertPolygonsPool(iAlertPolygonsPool);
    this.addObjectsPool(iAlertPolygonsPool);
  }

  setAcousticVector(iAcousticVectorPool) {
    aspObjects.setAcousticVectorPool(iAcousticVectorPool);
    this.addObjectsPool(iAcousticVectorPool);
  }
  
  public addObjectsPool(iObjectsPool: IObjectsPool) {
    this.objectsPools.set(iObjectsPool.getObjectType(), iObjectsPool);
  }
  
  public getObjectsPool(objectType: ObjectType): IObjectsPool {
    return this.objectsPools.has(objectType) ? this.objectsPools.get(objectType) : null;
  }
  
  public getObject(objectId) {
    for (let pool of this.objectsPools.values()) {
      let obj = pool.getObject(objectId);
      if (obj)
        return obj;
    }
    return null;
  }

  public deleteObject(objectId) {
    for (let pool of this.objectsPools.values()) {
      let obj = pool.getObject(objectId);
      if (obj) {
        pool.deleteObject(obj);
        break;
      }
    }
  }
  
  public allPoolsInitialized(): boolean {
    for (let pool of this.objectsPools.values()) {
      if (!pool.isInitialized())
        return false;
    }
    return true;
  }
  
  public hookObject(obj: AspObject): boolean {
    for (let pool of this.objectsPools.values()) {
      if (pool.hookable() && pool.hookObject(obj))
        return true;
    }
    return false;
  }
  
  public searchObjects(searchPattern: string): SearchResult[] {
    let results = [];
    for (let pool of this.objectsPools.values()) {
      if (pool.supportSearch()) {
        results.push(...pool.searchObjects(searchPattern));
      }
    } 
    return results;
  }
  
  public periodicUpdate() {
    for (let pool of this.objectsPools.values()) {
      pool.periodicUpdate();
    }
  }

  public deleteAllObjects() {
    for (let pool of this.objectsPools.values()) {
      pool.deleteAllObjects();
    }
  }

  public changeHooked(addedIds: Set<any>, removedIds: Set<any>) {
    for (let pool of this.objectsPools.values()) {
      if (pool.hookable()) {
        for (let id of removedIds.values()) {
          let obj = pool.getObject(id);
          if (obj)
            obj.setHooked(false);
        }
        for (let id of addedIds.values()) {
          let obj = pool.getObject(id);
          if (obj)
            obj.setHooked(true);
        }
      }
    }
  }

  public toggleHookedObjectsHistory() {
    for (let pool of this.objectsPools.values()) {
      pool.toggleHookedObjectsHistory();
    }
  }

  public changeHostilityOfTracks(hostility: number) {
    for (let pool of this.objectsPools.values()) {
      pool.changeHostilityOfTracks(hostility);
    }
  }

  public forceSendPolyToSmart() {
    for (let pool of this.objectsPools.values()) {
      pool.forceSendPolyToSmart();
    }
  }

};

export var aspMngr: AspMngr = null;

export function initAspMngr(mngr: AspMngr) {
  aspMngr = mngr;
}